export default __webpack_public_path__ + "static/media/untick.0d21a076.svg";